import {
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";

interface IResultUploadStudentSubsidyRecord {
  studentIdentifier: string;
  studentIdentifierType: string;
  studentName: string;
  status: "failed" | "success" | "pending";
  message: string;
}

interface ITableIResultUploadStudentSubsidy {
  records: IResultUploadStudentSubsidyRecord[];
}

const useStyles = makeStyles({
  table: {
    marginTop: "10px",
    padding: "1rem",
  },
  errorText: {
    color: "#da4040",
  },
});

const TableResultUploadStudentSubsidies = ({
  records,
}: ITableIResultUploadStudentSubsidy) => {
  const classes = useStyles();

  return (
    <TableContainer>
      <Table size="small" className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell>Student Identifier</TableCell>
            <TableCell>Student Identifier Type</TableCell>
            <TableCell>Student Name</TableCell>
            <TableCell>Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {records.map(
            (record: IResultUploadStudentSubsidyRecord, key: number) => {
              return (
                <TableRow key={`row-${key}`}>
                  <TableCell>{record.studentIdentifier}</TableCell>
                  <TableCell>{record.studentIdentifierType}</TableCell>
                  <TableCell>{record.studentName}</TableCell>
                  <TableCell
                    className={
                      record.status.toLowerCase() === "failed" &&
                      classes.errorText
                    }
                  >
                    {record.message}
                  </TableCell>
                </TableRow>
              );
            },
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableResultUploadStudentSubsidies;
